// src/components/Input.jsx
import React from "react";

export default function Input({ label, value, onChange, readOnly = false }) {
    return (
        <div>
            <label className="block text-sm text-gray-700 mb-1">{label}</label>
            <input
                type="text"
                value={value ?? ""}
                onChange={onChange}
                readOnly={readOnly}
                className="w-full px-3 py-2 border border-gray-300 rounded text-sm text-gray-900 bg-white focus:outline-none"
            />
        </div>
    );
}